







































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    projectId: String
  },
  data: function() {
    return {
      project: {
        id: '',
        slug: '',
        name: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetProject(this.projectId)
      .then(result => (this.project = result[0]))
      .finally(() => (this.loading = false))
  },
  methods: {
    deleteProject() {
      this.$api.clientAdmin
        .DeleteProject(this.project.id)
        .then(() => this.$router.push({ name: 'settings-projects-list' }))
    }
  }
}
